// Reads the browser-visible marker that says a session cookie exists, so a page
// that was built at build time can still show the right header.
//
// A prerendered page has no request behind it, so its HTML always carries the
// signed-out header. After hydration the browser reads this marker and the
// header swaps. The marker is written and cleared next to the session cookie
// itself ($lib/server/session), is not httpOnly on purpose, and holds no token.
//
// It decides nothing. The worst a stale or forged marker can do is offer the
// cabinet link to someone who does not have a session; following it lands on a
// page that reads the real session and sends them to sign in.

// The cookie's name lives here rather than beside the code that writes it: this
// module is safe to bundle into the browser, while the writing side is not, so
// the server imports the name from here and there is only ever one of it.
export const SIGNED_IN_HINT_COOKIE = "sd_signed_in";

/** Whether the signed-in marker is present in a `document.cookie` string. */
export function hasSignedInHint(cookieHeader: string): boolean {
  for (const part of cookieHeader.split(";")) {
    const separator = part.indexOf("=");
    if (separator === -1) continue;
    if (part.slice(0, separator).trim() !== SIGNED_IN_HINT_COOKIE) continue;
    return part.slice(separator + 1).trim() === "1";
  }
  return false;
}
